import React from 'react';
import { CarIcon, CheckIcon, ChevronLeftIcon, HeartIcon, SearchIcon, SlidersHorizontalIcon, TicketIcon, UserIcon, VideoIcon } from 'lucide-react';
import { parkeoCode, parkeoPins } from '../../data/reel';
export type ParkeoScreen = 'map' | 'code' | 'spot';
interface ParkeoPhoneProps {
  screen: ParkeoScreen;
}

/** Parkeo screens recreated from the Product-System Figma file (Plus Jakarta Sans, #3330E4). */
export function ParkeoPhone({
  screen
}: ParkeoPhoneProps) {
  return <div className="relative h-[640px] w-[310px] rounded-[52px] bg-ink p-[10px] shadow-lift" data-id="element-97" data-mp="wbu0zmjcenok">
      <div className="relative h-full w-full overflow-hidden rounded-[42px] bg-[#F4F5FA] text-[#2B2E32]" data-id="element-98" data-mp="iclx4gc8ire1">
        <div className="absolute left-1/2 top-[12px] z-20 h-[30px] w-[100px] -translate-x-1/2 rounded-full bg-ink" data-id="element-99" data-mp="mdo1tcox7vne" />
        {screen === 'map' && <MapScreen data-id="element-100" data-mp="2crohy0qc9lam" />}
        {screen === 'code' && <CodeScreen data-id="element-101" data-mp="2gryn5b6b47of" />}
        {screen === 'spot' && <SpotScreen data-id="element-102" data-mp="2gqx8yxtzv52h" />}
      </div>
    </div>;
}
function MapScreen() {
  const roads = ['left-0 top-[200px] h-[14px] w-full -rotate-[8deg]', 'left-0 top-[390px] h-[18px] w-full rotate-[4deg]', 'left-[120px] top-0 h-full w-[14px] rotate-[6deg]', 'left-[230px] top-0 h-full w-[10px] -rotate-[3deg]'];
  return <div className="relative h-full bg-[#E6E9F2]" data-id="element-103" data-mp="15ed1x6nyt0y4">
      {roads.map(r => <span key={r} className={`absolute bg-white ${r}`} data-id="element-104" data-mp="10dpcgpfdws60" />)}
      <div className="absolute inset-x-4 top-[52px] flex gap-2" data-id="element-105" data-mp="cmtfldw2n6rw">
        <div className="flex h-[40px] flex-1 items-center gap-2 rounded-full border border-[#E2E5F2] bg-white px-3 text-[12px] text-[#888FB2] shadow-[0_4px_16px_rgba(43,46,50,0.18)]" data-id="element-106" data-mp="7ojigxqsdw3n">
          <SearchIcon className="h-[15px] w-[15px]" data-id="element-107" data-mp="mjppno1mc0yk" />
          Search by city, area…
        </div>
        <span className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-white shadow-[0_4px_16px_rgba(43,46,50,0.18)]" data-id="element-108" data-mp="hosk4r3js9qf">
          <SlidersHorizontalIcon className="h-[15px] w-[15px]" data-id="element-109" data-mp="1t2e9oddbkdch" />
        </span>
      </div>
      {parkeoPins.map(p => <span key={p.price + p.x} className="absolute rounded-full bg-[#2B2E32] px-2.5 py-1 text-[12px] font-bold text-white" style={{
      left: p.x,
      top: p.y
    }} data-id="element-110" data-mp="2049ker7wx1og">
          {p.price}
        </span>)}
      <span className="absolute left-[118px] top-[300px] h-[56px] w-[56px] rounded-full bg-[#3330E4]/15" data-id="element-111" data-mp="2a1ebn5gm7nc4" />
      <span className="absolute left-[138px] top-[320px] h-[16px] w-[16px] rounded-full border-[3px] border-white bg-[#3330E4]" data-id="element-112" data-mp="1hel7ed40o5xd" />
      <span className="absolute bottom-[96px] left-1/2 -translate-x-1/2 whitespace-nowrap rounded-[7px] border border-[#CFD3E5] bg-white px-2.5 py-1.5 text-[10px] text-[#464F68]" data-id="element-113" data-mp="1mcv3qr1h9ckk">
        Prices are for 1 day
      </span>
      <div className="absolute inset-x-0 bottom-0 grid h-[76px] grid-cols-4 bg-white pt-3 shadow-[0_-4px_24px_rgba(43,46,50,0.12)]" data-id="element-114" data-mp="1w497xc4dj0k1">
        {[CarIcon, TicketIcon, HeartIcon, UserIcon].map((Icon, i) => <span key={i} className={`flex flex-col items-center gap-1 text-[10px] font-bold ${i === 0 ? 'text-[#3330E4]' : 'text-[#CFD3E5]'}`} data-id="element-115" data-mp="13llt2efz0hre" data-mpi={i}>
            <Icon className="h-[20px] w-[20px]" data-id="element-116" data-mp="3cw4c8sfxf8ar" />
            {i === 0 && 'Parking'}
          </span>)}
      </div>
    </div>;
}
function CodeScreen() {
  return <div className="flex h-full flex-col" data-id="element-117" data-mp="37yuoric3l6pk">
      <div className="px-5 pt-[64px]" data-id="element-118" data-mp="32yggq0ahxwrj">
        <p className="text-[26px] font-bold leading-tight" data-id="element-119" data-mp="32xf4hshqv488">Enter the code</p>
        <p className="mt-2 text-[12px] leading-snug" data-id="element-120" data-mp="2xzlwqv0sm25u">Sent the 6-digit code to +34 640 50 82 59</p>
        <div className="mt-5 flex gap-[6px]" data-id="element-121" data-mp="2t6sse898kvua">
          {parkeoCode.map((d, i) => <span key={i} className="flex h-[36px] w-[36px] items-center justify-center rounded-full border border-[#E2E5F2] bg-white text-[13px] text-[#3330E4]" data-id="element-122" data-mp="2p5h4q89xakoq" data-mpi={i}>
              {d}
            </span>)}
        </div>
      </div>
      <div className="mt-auto" data-id="element-123" data-mp="2a99kx92ffl9z">
        <div className="mx-5 mb-4 rounded-full bg-[#3330E4] py-3 text-center text-[13px] font-bold text-white" data-id="element-124" data-mp="2aa16rs6824n2">Continue</div>
        <div className="grid grid-cols-3 gap-1.5 bg-[#D1D5DB] p-1.5 pb-6" data-id="element-125" data-mp="e6mwra0ecjhd">
          {['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', '⌫'].map((k, i) => <span key={i} className={`flex h-[38px] items-center justify-center rounded-[5px] text-[18px] ${k && k !== '⌫' ? 'bg-[#FCFCFE] shadow-[0_1px_0_#898A8D]' : ''}`} data-id="element-126" data-mp="4f0eitpn5k54" data-mpi={i}>
              {k}
            </span>)}
        </div>
      </div>
    </div>;
}
function SpotScreen() {
  const steps = [{
    label: 'Date/Time',
    state: 'done'
  }, {
    label: 'Spot',
    state: 'active'
  }, {
    label: 'Payment',
    state: 'todo'
  }] as const;
  const spots = ['car', 'car', 'P203', 'car', 'P201', 'P204', 'car', 'P202'];
  return <div className="flex h-full flex-col" data-id="element-127" data-mp="1fvgnc46ox2j0">
      <div className="flex items-center justify-between px-4 pt-[50px]" data-id="element-128" data-mp="1fvqdpsvndbp8">
        <span className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-white" data-id="element-129" data-mp="1kujupva57ku5">
          <ChevronLeftIcon className="h-[16px] w-[16px]" data-id="element-130" data-mp="35bkodn2upb0t" />
        </span>
        <div className="text-center" data-id="element-131" data-mp="30dj2yvhyczm6">
          <p className="text-[15px] font-bold" data-id="element-132" data-mp="30eket26slq4y">Book your spot</p>
          <p className="text-[10px]" data-id="element-133" data-mp="3f1vsb9mjbk7p">at La Guindalera Parking</p>
        </div>
        <span className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-[#2B2E32] text-white" data-id="element-134" data-mp="3f3ys2ldhorpm">
          <VideoIcon className="h-[14px] w-[14px]" data-id="element-135" data-mp="3o2k3zxogh8hf" />
        </span>
      </div>
      <div className="mt-4 flex justify-center gap-6" data-id="element-136" data-mp="3o4ohn7c5pluw">
        {steps.map(s => <div key={s.label} className="flex flex-col items-center gap-1" data-id="element-137" data-mp="3k0ysogrkl29c">
            <span className={`flex h-[20px] w-[20px] items-center justify-center rounded-full text-[10px] ${s.state === 'done' ? 'bg-[#51B286] text-white' : s.state === 'active' ? 'bg-[#3330E4] text-white' : 'bg-[#CFD3E5] text-[#888FB2]'}`} data-id="element-138" data-mp="1uaulauxtfd6">
              {s.state === 'done' ? <CheckIcon className="h-[12px] w-[12px]" strokeWidth={3} data-id="element-139" data-mp="1yq06taj7sbyz" /> : s.state === 'active' ? '2' : '3'}
            </span>
            <span className={`text-[10px] ${s.state === 'done' ? 'text-[#51B286]' : s.state === 'active' ? 'text-[#3330E4]' : 'text-[#888FB2]'}`} data-id="element-140" data-mp="7ju5818qjghc">
              {s.label}
            </span>
          </div>)}
      </div>
      <div className="mt-4 flex gap-2 overflow-hidden pl-4" data-id="element-141" data-mp="gkscqtidu64o">
        {['1st Floor · 40', '2nd Floor · 25'].map((f, i) => <span key={f} className={`shrink-0 rounded-[10px] border-2 bg-white px-3 py-2 text-[11px] ${i === 1 ? 'border-[#3330E4]' : 'border-[#E2E5F2]'}`} data-id="element-142" data-mp="lj3oj9s8mqpj" data-mpi={i}>
            <span className="block font-bold" data-id="element-143" data-mp="vapvgtxjm3mh">{f.split(' · ')[0]}</span>
            <span className="text-[#3330E4]" data-id="element-144" data-mp="zbjmvxa720k4">{f.split(' · ')[1]} spots available</span>
          </span>)}
      </div>
      <div className="mx-4 mt-5 grid grid-cols-2 gap-x-6" data-id="element-145" data-mp="14bfndmjon9ux">
        {spots.map((s, i) => <div key={i} className="flex h-[52px] items-center justify-center border-b border-[#CFD3E5]" data-id="element-146" data-mp="19a90veyyz0v3" data-mpi={i}>
            {s === 'car' ? <span className="h-[30px] w-[62px] rounded-[8px] bg-[#2B2E32] p-[4px]" data-id="element-147" data-mp="1jb1ordmnk3ma">
                <span className="block h-full w-[60%] rounded-[5px] bg-white/20" data-id="element-148" data-mp="1ecqckw8vxh0w" />
              </span> : <span className={`flex h-[40px] w-[80px] items-center justify-center rounded-[6px] text-[12px] ${s === 'P201' ? 'border-2 border-[#3330E4] bg-[#E0EAFF] font-bold text-[#3330E4]' : 'text-[#888FB2]'}`} data-id="element-149" data-mp="19grufqe5gv8x">
                {s}
              </span>}
          </div>)}
      </div>
      <div className="mt-auto flex items-center justify-between bg-white px-4 py-4" data-id="element-150" data-mp="1sc9idie84ga1">
        <div data-id="element-151" data-mp="1obfyr17tdnmy">
          <p className="text-[16px] font-bold" data-id="element-152" data-mp="1obz3thcd8hjk">€208</p>
          <p className="text-[10px] font-semibold text-[#464F68] underline" data-id="element-153" data-mp="2kuncb6wfvi3u">May 10–18, 2025</p>
        </div>
        <span className="rounded-full bg-[#3330E4] px-5 py-2.5 text-[12px] font-bold text-white" data-id="element-154" data-mp="2g356o5jh0tcj">Continue</span>
      </div>
    </div>;
}